"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _ComparisonDataDisplay = require("../ComparisonDataDisplay.styled");
var _SpecBoxContentData = _interopRequireDefault(require("./SpecBoxContentData"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const SpecBoxContent = _ref => {
  let {
    spec,
    productId,
    value,
    showAllProducts,
    applyShowDifferences,
    label
  } = _ref;
  const breakpoints = (0, _r10SourceLibrary.useBreakpoints)();
  const gridColumnProps = label === 'Colors' && {
    col: 5,
    colMd: 4
  };
  const ColWrapper = (0, _react.useCallback)(showAllProducts && breakpoints.sm ? _ComparisonDataDisplay.StyledGridColumnWrapper : _r10SourceLibrary.GridColumn, [showAllProducts, breakpoints.sm]);
  return /*#__PURE__*/_react.default.createElement(ColWrapper, gridColumnProps, /*#__PURE__*/_react.default.createElement(_SpecBoxContentData.default, {
    spec: spec,
    productId: productId,
    value: value,
    applyShowDifferences: applyShowDifferences,
    label: label
  }));
};
var _default = SpecBoxContent;
exports.default = _default;